import {
  formatPaymentStatusLabel,
  formatPkrAmount,
} from "../utils/studentFeeState";
import "./FeeMonthProjection.css";

export default function FeeMonthProjection({
  groups = [],
  totals = { charged: 0, paid: 0, remaining: 0 },
  compact = false,
  hideHead = false,
}) {
  if (!groups.length) return null;

  return (
    <div
      className={`fee-month-projection${
        compact ? " fee-month-projection--compact" : ""
      }`}
    >
      {hideHead ? null : (
        <div className="fee-month-projection__head">
          <h3 className="fee-month-projection__title">Payment history</h3>
          <p className="fee-month-projection__lede">
            Grouped by course, with months under each
          </p>
        </div>
      )}

      <div className="fee-month-projection__totals">
        <div className="fee-month-projection__total">
          <span>Charged</span>
          <strong>{formatPkrAmount(totals.charged)}</strong>
        </div>
        <div className="fee-month-projection__total fee-month-projection__total--paid">
          <span>Paid</span>
          <strong>{formatPkrAmount(totals.paid)}</strong>
        </div>
        <div className="fee-month-projection__total fee-month-projection__total--due">
          <span>Amount due</span>
          <strong>{formatPkrAmount(totals.remaining)}</strong>
        </div>
      </div>

      <div className="fee-month-projection__groups">
        {groups.map((group) => (
          <section key={group.key} className="fee-month-projection__group">
            <div className="fee-month-projection__group-head">
              <h4 className="fee-month-projection__group-title">
                {group.courseTitle}
              </h4>
              <div className="fee-month-projection__group-totals">
                <span>Charged {formatPkrAmount(group.charged)}</span>
                <span>Paid {formatPkrAmount(group.paid)}</span>
                <span className="fee-month-projection__group-due">
                  Due {formatPkrAmount(group.remaining)}
                </span>
              </div>
            </div>

            <div className="fee-month-projection__table-wrap">
              <table className="fee-month-projection__table">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Charged</th>
                    <th>Paid</th>
                    <th>Remaining</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {group.months.map((row) => (
                    <tr key={row.key}>
                      <td>{row.monthLabel}</td>
                      <td>{formatPkrAmount(row.charged)}</td>
                      <td>{formatPkrAmount(row.paid)}</td>
                      <td>{formatPkrAmount(row.remaining)}</td>
                      <td>
                        <span
                          className={`fee-month-projection__status fee-month-projection__status--${row.status}`}
                        >
                          {formatPaymentStatusLabel(row.status)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
